import React from 'react';
import { css } from 'emotion';
import { pillarPalette } from '@root/src/lib/pillars';
import { textSans } from '@guardian/src-foundations/typography';
import { between } from '@guardian/src-foundations/mq';
import { formatCount } from '@root/src/web/lib/formatCount';
import CommentIcon from '@frontend/static/icons/comment.svg';
const containerStyles = (pillar) => css `
	display: flex;
	align-self: flex-end;
	flex-direction: column;
	${textSans.medium()};
	font-weight: bold;
	color: ${pillarPalette[pillar].main};
	padding-top: 5px;
`;
const iconContainerStyles = css `
	height: 15px;
	margin: 0;
	text-align: right;
	margin-bottom: -2px;
	svg {
		height: 18px;
		width: 18px;
	}
`;
const iconStyles = (pillar) => css `
	fill: ${pillarPalette[pillar].main};
`;
const longStyles = css `
	display: block;

	${between.leftCol.and.wide} {
		display: none;
	}
`;
const shortStyles = css `
	display: none;

	${between.leftCol.and.wide} {
		display: block;
	}
`;
const linkStyles = css `
	color: inherit;
	text-decoration: none;
	:hover {
		text-decoration: underline;
	}
	:visited {
		color: inherit;
	}
`;
export const CommentCount = ({ isCommentable, commentCount, pillar, setIsExpanded, }) => {
    if (!isCommentable)
        return null;
    const { short, long } = formatCount(commentCount);
    return (React.createElement("div", { className: containerStyles(pillar), "data-cy": "comment-counts" },
        React.createElement("a", { href: "#comments", className: linkStyles, "aria-label": `${short} Comments`, onClick: () => setIsExpanded(true) },
            React.createElement("div", { className: iconContainerStyles },
                React.createElement(CommentIcon, { className: iconStyles(pillar) })),
            React.createElement("div", { "data-testid": "long-comment-count", className: longStyles, "aria-hidden": "true" }, long),
            React.createElement("div", { "data-testid": "short-comment-count", className: shortStyles, "aria-hidden": "true" }, short))));
};
